import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home1.page').then((m) => m.Home1Page),
  },
  // {
  //   path: 'home1',
  //   loadComponent: () => import('./pages/home/home1.page').then((m) => m.Home1Page),
  // },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/cart/cart.page').then( m => m.CartPage)
  },
  {
    path: 'account',
    loadComponent: () => import('./pages/account/account.page').then( m => m.AccountPage)
  },
  {
    path: 'message',
    loadComponent: () => import('./pages/message/message.page').then( m => m.MessagePage)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then( m => m.routes)
  },
  {
    path: 'store-listing',
    loadComponent: () => import('./pages/store-listing/store-listing.page').then( m => m.StoreListingPage)
  },
  {
    path: 'product-top-deals',
    loadComponent: () => import('./pages/home/product-top-deals/product-top-deals.page').then( m => m.ProductTopDealsPage)
  },
  {
    path: 'service-top-deals',
    loadComponent: () => import('./pages/home/service-top-deals/service-top-deals.page').then( m => m.ServiceTopDealsPage)
  },
  {
    path: 'events',
    loadComponent: () => import('./pages/home/events/events.page').then( m => m.EventsPage)
  },
  {
    path: 'store/:storeId',
    loadComponent: () => import('./pages/store/store.page').then( m => m.StorePage)
  },
  {
    path: 'item/:itemId',
    loadComponent: () => import('./pages/item/item.page').then( m => m.ItemPage)
  },
  {
    path: 'event-item/:eventId',
    loadComponent: () => import('./pages/event-item/event-item.page').then( m => m.EventItemPage)
  },
  {
    path: 'service-item/:itemId',
    loadComponent: () => import('./pages/service-item/service-item.page').then( m => m.ServiceItemPage)
  },
  {
    path: 'checkout-login',
    loadComponent: () => import('./pages/checkout-login/checkout-login.page').then( m => m.CheckoutLoginPage)
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout.page').then( m => m.CheckoutPage)
  },
  {
    path: 'event-checkout',
    loadComponent: () => import('./pages/event-checkout/event-checkout.page').then( m => m.EventCheckoutPage)
  },
  {
    path: 'order-confirmation',
    loadComponent: () => import('./pages/order-confirmation/order-confirmation.page').then( m => m.OrderConfirmationPage)
  },
  {
    path: 'order-history',
    loadComponent: () => import('./pages/order-history/order-history.page').then( m => m.OrderHistoryPage)
  },
  {
    path: 'order-details',
    loadComponent: () => import('./pages/order-history/order-details/order-details.page').then( m => m.OrderDetailsPage)
  },
  {
    path: 'order-details/:orderId',
    loadComponent: () => import('./pages/order-history/order-details/order-details.page').then( m => m.OrderDetailsPage)
  },
  {
    path: 'service-details/:orderId',
    loadComponent: () => import('./pages/order-history/service-details/service-details.page').then( m => m.ServiceDetailsPage)
  },
  {
    path: 'service-item',
    loadComponent: () => import('./pages/service-item/service-item.page').then( m => m.ServiceItemPage)
  },
  {
    path: 'phone-login',
    loadComponent: () => import('./pages/phone-login/phone-login.page').then( m => m.PhoneLoginPage)
  },
  {
    path: 'event-payment-success/:eventId/:orderId', // Route parameters for event and order ID
    loadComponent: () => import('./pages/event-payment-success/event-payment-success.page').then( m => m.EventPaymentSuccessPage)
  },
  {
    path: 'event-item',
    loadComponent: () => import('./pages/event-item/event-item.page').then( m => m.EventItemPage)
  },
];
